var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0953 8.63111C18.276 8.50719 18.355 8.28004 18.2901 8.07073C18.2252 7.86143 18.0316 7.71875 17.8125 7.71875H11.7929L9.97552 2.12671C9.90857 1.92071 9.7166 1.78125 9.5 1.78125C9.2834 1.78125 9.09143 1.92071 9.02448 2.12671L7.20707 7.71875H1.1875C0.968374 7.71875 0.77478 7.86143 0.709911 8.07073C0.645043 8.28004 0.724016 8.50719 0.904736 8.63111L5.78812 11.9797L3.90516 17.5589C3.83559 17.765 3.90729 17.9924 4.08247 18.1214C4.25766 18.2504 4.49614 18.2513 4.67229 18.1236L9.5 14.6253L14.3277 18.1236C14.5039 18.2513 14.7423 18.2504 14.9175 18.1214C15.0927 17.9924 15.1644 17.765 15.0948 17.5589L13.2119 11.9797L18.0953 8.63111Z",
    fill: "#FAAD39",
    stroke: "#FAAD39",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a90acd20d1c1398046a91f56d2b24736.svg";
export { ForwardRef as ReactComponent };